var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingTx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,0H100V100H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.159,22.083,60.235,40.167H72.928c0,14.964-11.382,27.125-25.386,27.125a23.585,23.585,0,0,1-11.847-3.165l-6.177,6.6a32.007,32.007,0,0,0,18.024,5.606c18.7,0,33.848-16.185,33.848-36.167H94.083Zm-55,18.083c0-14.964,11.382-27.125,25.386-27.125a23.585,23.585,0,0,1,11.847,3.165l6.177-6.6A32.007,32.007,0,0,0,47.542,4C28.84,4,13.693,20.185,13.693,40.167H1L17.924,58.25,34.848,40.167Z",
    transform: "translate(2.458 9.833)",
    fill: "#e8e8e8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTx);
export default __webpack_public_path__ + "static/media/pending-tx.ce322cc35e135b9f5ae3e2e636f99d38.svg";
export { ForwardRef as ReactComponent };